module.exports = __webpack_public_path__ + "static/media/Issue_Update_white_Icon.ea772aea.svg";